import React from 'react'
import axios from 'axios';
import { baseUrl } from '../../../assets/Animations';
import TeacherCalendarFamilySearch from './TeacherCalendarFamilySearch/TeacherCalendarFamilySearch';
import TeacherCalendarLessonDetails from './TeacherCalendarLessonDetails/TeacherCalendarLessonDetails';
import { convertStringToUTCString, getSchoolIANATimezone } from '../../../Calendar/calendarFunctions';

const NewTeacherCalendarEvent = ({event, setEvent, teachersFamilies, setAllEvents, socket}) => {
    const [step, setStep] = React.useState(1)
    const [loading, setLoading] = React.useState(false)

    const createCalendarEvent = (event) => {
        setLoading(true)
        let utcDateTimeEvent = {...event, dateTime: convertStringToUTCString(event.dateTime, getSchoolIANATimezone(event.school))}
        axios.post(`${baseUrl}/calendar`, {event: utcDateTimeEvent})
        .then((res) => {
          setEvent(false)
          setLoading(false)
          socket.emit('createCalendarEvent', {emitter: res.data.teacherName, packet: res.data})
          setAllEvents(prev => ([...prev, res.data]))
        })
        .catch((err) => {
            console.log(err)
        })
      }

    if(event) return (
        <div>
            {step === 1 && <TeacherCalendarFamilySearch teachersFamilies={teachersFamilies} setStep={setStep} event={event} setEvent={setEvent} loading={loading} />}
            {step === 2 && <TeacherCalendarLessonDetails setStep={setStep} event={event} setEvent={setEvent} createCalendarEvent={createCalendarEvent} setLoading={setLoading} loading={loading} />}
        </div>
    )
    else return null
}
export default NewTeacherCalendarEvent;